'use client'

import { createContext, useContext } from 'react'

const EmbedTokenContext = createContext('')

export function EmbedTokenProvider({ token, children }: { token: string; children: React.ReactNode }) {
  return (
    <EmbedTokenContext.Provider value={token}>
      {children}
    </EmbedTokenContext.Provider>
  )
}

export function useEmbedToken() {
  return useContext(EmbedTokenContext)
}
